import React, { ReactNode } from 'react';
import { Formik, Form, FormikConfig } from 'formik';

type Overwrite<T1, T2> = { [P in Exclude<keyof T1, keyof T2>]?: T1[P] } & T2;

type FormWrapperProps<V> = Overwrite<
  FormikConfig<V>,
  {
    className?: string;

    /*
     * Make sure using form tag html or <Form> component of formik parent component
     */
    isRenderOuter?: boolean;
  }
>;

export function FormWrapper<V>(props: FormWrapperProps<V>) {
  const newProps: FormikConfig<V> = {
    ...props,
    initialValues: props.initialValues || ({} as V),
    onSubmit: props.onSubmit || (() => {}),
  };

  return (
    <Formik {...newProps} validateOnChange validateOnBlur>
      {props.isRenderOuter ? props.children : <Form className={props.className}>{props.children as ReactNode}</Form>}
    </Formik>
  );
}
